import React from 'react';
import styled from "styled-components";
import useZibi from "../../zibi/UseZibi";
import Paper from "@mui/material/Paper";
import {addOrDeleteQueryParams} from "../../domain/queryHandler";
import {useLocation, useNavigate} from "react-router-dom";

const WrapperStyled = styled.div`
    padding: 20px;
    display: grid;
    //grid-template-columns: 300px;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 15px;
`;

const ItemStyled = styled.div`
    padding: 10px;
    position: relative;
    cursor: pointer;
`;

const Sites = ({clientId}) => {
    const history = useNavigate();
    const location = useLocation();
    const [sitesByClientId] = useZibi('sitesByClientId');

    const sites = sitesByClientId?.[clientId] || [];

    const changeUrl = (query) => {
        history({
            search: query
        });
    };
    return (
        <WrapperStyled>
            {sites.map((site) => {
                return (
                    <Paper
                        onClick={() => {
                            const urlToPush = addOrDeleteQueryParams(location, [{site: site._id}, {edge: null}]);
                            changeUrl(urlToPush);
                        }}
                        key={site._id} elevation={3}>
                        <ItemStyled>
                            {site.name}
                        </ItemStyled>
                    </Paper>
                );
            })}
        </WrapperStyled>
    );
};

export default Sites;